import React, { useState } from 'react';
import Button from '../atoms/Button';
import Input from '../atoms/Input';

export default function AddTableCard({ level, onAdd }) {
  const [name, setName] = useState('');
  const handleSubmit = (event) => {
    event.preventDefault();
    const trimmedName = name.trim();
    if (!trimmedName) return;
    onAdd?.(trimmedName);
    setName('');
  };

  return (
    <form className="ca-add-table-card" onSubmit={handleSubmit}>
      <span className="ca-add-table-card__level">L{level}</span>
      <label className="ca-add-table-card__label" htmlFor={`add-workflow-level-${level}`}>Name Level {level}</label>
      <Input id={`add-workflow-level-${level}`} value={name} placeholder={`Enter name for L${level}`} onChange={(event) => setName(event.target.value)} />
      <Button type="submit" className="ca-add-table-card__button" disabled={!name.trim()}>+ Add L{level}</Button>
    </form>
  );
}